import { Component, OnInit } from '@angular/core';
import {CinchDataService} from "../../common/service/cinch-data.service";
import {AuthService} from "../../common/service/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-header-my-account',
  templateUrl: './header-my-account.component.html',
  styleUrls: ['./header-my-account.component.scss']
})
export class HeaderMyAccountComponent implements OnInit {

  constructor( private cinchData: CinchDataService,
               private authService: AuthService,
               public router: Router ) { }

  ngOnInit() {
  }

  logout(){
      this.cinchData.prodSub = this.cinchData._sub = "";
      this.authService.logout();
      this.router.navigate(["/"]);
  }

}
